import { BaseTranslation } from 'src/i18n/i18n-types';

export const general: BaseTranslation = {
  timeAgo: '{time} ago',
};
